import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";
import KeyboardVoiceOutlinedIcon from "@mui/icons-material/KeyboardVoiceOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import * as styles from "../styles/StickyNav.module.scss";
import { Constants } from "../Constants";
import { useTranslation } from "react-i18next";
import { useNavUrls } from "../hooks/useNavUrls";
import { useMsal } from "@azure/msal-react";

const StickyBar = () => {
  const { t } = useTranslation();
  const { instance, inProgress } = useMsal();
  const location = useLocation();
  const from = location.state?.from;
  const urls = Constants.navigation.urls;
  const navUrls = useNavUrls(inProgress, instance);

  // Determine the current active tab based on the pathname
  const getActiveTab = () => {
    if (
      location.pathname === urls.home ||
      (location.pathname === urls.profile && from === urls.home)
    )
      return 0;
    if (
      location.pathname === urls.account ||
      location.pathname === urls.language ||
      location.pathname === urls.feedback ||
      (location.pathname === urls.profile && from === urls.account)
    )
      return 3;
    return -1; // No tab selected (e.g., external link)
  };

  const [value, setValue] = useState(getActiveTab());

  useEffect(() => {
    setValue(getActiveTab());
  }, [location]);

  return (
    <Box className={styles.StickyNav}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        sx={{
          boxShadow: 1,
        }}
      >
        <BottomNavigationAction
          label={t(Constants.translationKeys.sticky_nav_home)}
          icon={<GridViewOutlinedIcon className={styles.icon} />}
          component={Link}
          to={Constants.navigation.urls.home}
          disableRipple
          data-parentid="sticky-nav"
          data-id="Home"
        />
        <BottomNavigationAction
          label={t(Constants.translationKeys.sticky_nav_ai_chat)}
          icon={<TextsmsOutlinedIcon className={styles.icon} />}
          component={Link}
          to={navUrls?.find(urlObj => urlObj.key === "ai-chat")?.url || "#"}
          target="_blank"
          disableRipple
          data-parentid="sticky-nav"
          data-id="AI Chat"
        />
        <BottomNavigationAction
          label={t(Constants.translationKeys.sticky_nav_ai_note)}
          icon={<KeyboardVoiceOutlinedIcon className={styles.icon} />}
          component={Link}
          to={navUrls?.find(urlObj => urlObj.key === "ai-notes")?.url || "#"}
          target="_blank"
          disableRipple
          data-parentid="sticky-nav"
          data-id="AI Note"
        />
        <BottomNavigationAction
          label={t(Constants.translationKeys.sticky_nav_account)}
          icon={<AccountCircleOutlinedIcon className={styles.icon} />}
          component={Link}
          to={Constants.navigation.urls.account}
          disableRipple
          data-parentid="sticky-nav"
          data-id="Account"
        />
      </BottomNavigation>
    </Box>
  );
};

export default StickyBar;
